import {environment} from "../../../environments/environment";


export const GLOBAL = {
  url: environment.general.url
};

export function showFilterChekingAccount(): boolean {
  return environment.general.product !== 'balton-lotes' && environment.general.product !== 'rapeca'
    && environment.general.product !== 'Martinez'  ;
}
